module.exports = __webpack_public_path__ + "assets/star.cb0fdf17.svg";